import {styled} from '../ui/theme';

export const BackgroundPhoto = styled.div`
    background-image: url('/images/bg.png');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    display: inline-block;
    position: absolute;
    &:before {
        content: '';
        width: 100%;
        height: 100%;
        background-image: linear-gradient(to right, rgba(0, 201, 255, 0.9), rgba(6, 156, 193, 0.9));
        background-size: cover;
        background-position: center 80px;
        position: absolute;
        left: 0;
        top: 0;
        display: inline-block;
    }
`;
